import { Button, MailIcon, Stack, Table, TableCell, TableRow } from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type PendingUserRow = {
  no: number;
  id: string;
  full_name: string;
  email: string;
  created_at: string;
  account_information_sent_at: string;
};

type Props = {
  rows: PendingUserRow[];
  onSort: (column: string) => void;
  /** 未指定の場合、行クリックによる /users/:id への遷移を無効化する */
  onClickRow?: (userId: string) => void;
  onClickSendReminder: (userId: string, fullName: string) => void;
};

export const PendingUserTableContent = ({
  rows,
  onSort,
  onClickRow,
  onClickSendReminder,
}: Props) => {
  if (!rows || rows.length === 0) {
    return <div className={styles.emptyTable}>データなし</div>;
  }

  return (
    <Table
      scrollable
      fixedHeader
      maxHeight='min(720px, 90vh)'
      headers={[
        { label: 'No', sortable: true, onSort: () => onSort('no') },
        { label: '名前', sortable: true, onSort: () => onSort('full_name') },
        { label: 'メールアドレス', sortable: true, onSort: () => onSort('email') },
        { label: '作成日時', sortable: true, onSort: () => onSort('created_at') },
        {
          label: '招待日時',
          sortable: true,
          onSort: () => onSort('account_information_sent_at'),
        },
        { label: '再招待メール' },
      ]}
    >
      {rows.map(row => (
        <TableRow key={row.id} onClick={onClickRow ? () => onClickRow(row.id) : undefined}>
          <TableCell>{row.no}</TableCell>
          <TableCell>{row.full_name ?? '-'}</TableCell>
          <TableCell>{row.email ?? '-'}</TableCell>
          <TableCell>{row.created_at ?? '-'}</TableCell>
          <TableCell>{row.account_information_sent_at ?? '-'}</TableCell>
          <TableCell>
            <Stack justifyContent='center' alignItems='center'>
              <Button
                variant='outline'
                size='sm'
                icon={<MailIcon size='xs' />}
                iconPosition='left'
                onClick={e => {
                  e.stopPropagation();
                  onClickSendReminder(row.id, row.full_name);
                }}
              >
                送信
              </Button>
            </Stack>
          </TableCell>
        </TableRow>
      ))}
    </Table>
  );
};
